import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig'; 
import { collection, query, where, getDocs } from 'firebase/firestore'; // Changed onSnapshot to getDocs for simpler data fetching
import { useAuth } from '../context/AuthContext';
import Comments from './Comments';
import './TouristSpots.css';

const TouristSpots = () => {
    const { countryName } = useParams();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    
    const [country, setCountry] = useState(null);
    const [spots, setSpots] = useState([]); // New state specifically for spots
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // 1. Find the Country Document
                const countryQ = query(
                    collection(db, "countries"), 
                    where("name", "==", countryName)
                );
                
                const countrySnapshot = await getDocs(countryQ);

                if (countrySnapshot.empty) {
                    setError("Country not found.");
                    setLoading(false);
                    return;
                }

                // Get the first matching country (assuming names are unique)
                const countryDoc = countrySnapshot.docs[0];
                const countryData = countryDoc.data();
                const countryId = countryDoc.id;

                setCountry(countryData);

                // 2. NOW fetch the 'touristSpots' Sub-collection using the countryId
                const spotsRef = collection(db, "countries", countryId, "touristSpots");
                const spotsSnapshot = await getDocs(spotsRef);

                const spotsList = spotsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                setSpots(spotsList); // Save spots to state
                setLoading(false);

            } catch (err) {
                console.error("Error fetching data:", err);
                setError("Failed to load data.");
                setLoading(false);
            }
        };

        fetchData();
    }, [countryName]);

    if (loading) return <h2 style={{ textAlign: 'center', marginTop: '50px' }}>Loading...</h2>;
    if (error) return <h2 style={{ textAlign: 'center', marginTop: '50px' }}>{error}</h2>;
    if (!country) return <h2>Country not found</h2>;

    return (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
             <button onClick={() => navigate(-1)} className="back-button">
                &#x2190;
            </button>
            <h2>Tourist Spots in {countryName}<br></br>(click to view details)</h2>
            <p className="welcome-message">{country.welcomeMessage}</p>
            
            <div className="tourist-spots-container">
                {/* We now map through the 'spots' state, not country.touristSpots */}
                {spots.length > 0 ? (
                    spots.map((spot) => (
                        <Link key={spot.name} to={`/destinations/${countryName}/${spot.name}`} className="grid-item-link">
                            <div
                                className="grid-card"
                                style={{
                                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${spot.image})`,
                                }}
                            >
                                {spot.name}
                            </div>
                        </Link>
                    ))
                ) : (
                    <p>No tourist spots listed for this country yet.</p>
                )}
            </div>
            {isAuthenticated && <Comments key={countryName} countryName={countryName} />}
        </div>
    );
};

export default TouristSpots;